// 贷超

import { lazy, Suspense } from "react"

const ThreeAuthOcr = lazy(() => import("@/pages/income/threeAuthOcr/ThreeAuthOcr"))
const Preview = lazy(() => import("@/pages/income/preview/Preview"))
const CompleteInfo = lazy(() => import("@/pages/income/completeInfo/CompleteInfo"))
const Sign = lazy(() => import("@/pages/sign/Sign"))
const BankAccount = lazy(() => import("@/pages/sign/BankAccount"))
const RepaymentPlan = lazy(() => import("@/pages/sign/repaymentPlan"))
const SignAgreement = lazy(() => import("@/pages/sign/signAgreement"))
const Redirect = lazy(() => import("@/pages/redirect/Redirect"))
const CompleteResult = lazy(() => import("@/pages/income/completeResult/CompleteResult"))
const SigningPreview = lazy(() => import("@/pages/sign/signingPreview/SigningPreview"))
const SigningPreviewWaiting = lazy(() => import("@/pages/sign/signingPreview/SigningPreviewWaiting"))
const Face = lazy(() => import("@/pages/face/Face"))
const RepaymentOrder = lazy(() => import("@/pages/repayment/order/Order"))
const RepaymentDetail = lazy(() => import("@/pages/repayment/detail/Detail"))

const shiliangRouter = [
  {
    path: "redirect",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Redirect />
      </Suspense>
    )
  },
  {
    path: "gqs-sign",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Sign />
      </Suspense>
    ),
  },
  {
    path: "gqs-signingPreview",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <SigningPreview />
      </Suspense>
    ),
  },
  {
    path: "gqs-signingPreviewWaiting",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <SigningPreviewWaiting />
      </Suspense>
    ),
  },
  {
    path: "gqs-bankAccount",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <BankAccount />
      </Suspense>
    ),
  },
  {
    path: "gqs-repaymentPlan",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <RepaymentPlan />
      </Suspense>
    ),
  }, 
  {
    path: "gqs-signAgreement",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <SignAgreement />
      </Suspense>
    ),
  },
  {
    path: "three-auth-ocr",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <ThreeAuthOcr />
      </Suspense>
    ),
  },
  {
    path: "preview",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Preview />
      </Suspense>
    ),
  },
  {
    path: "complete-info",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <CompleteInfo />
      </Suspense>
    ),
  },
  {
    path: "complete-result",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <CompleteResult />
      </Suspense>
    ),
  },
  {
    path: "gqs-face",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Face />
      </Suspense>
    )
  },
  {
    path: "repayment-order",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <RepaymentOrder />
      </Suspense>
    )
  },
  {
    path: "repayment-detail",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <RepaymentDetail />
      </Suspense>
    )
  },
]

export default shiliangRouter